import {daltonizeImage} from "./daltonize_images"

function preloadImage(imageUrl) {
  if (window.gon.colorBlindness === "normal") {
    return createImage(imageUrl)
  }
  return daltonizeImage(imageUrl)
}

// https://github.com/mbrevda/react-image/blob/
// d127cfe469e41c1f8658e57d2638db4c452a90d3/
// src/imagePromiseFactory.ts
// https://github.com/mbrevda/react-image#decode-before-paint
function createImage(imageUrl) {
  return new Promise((resolve, reject) => {
    const image = new Image()
    image.crossOrigin = "Anonymous"
    image.onload = () => {
      if (image.decode) {
        image.decode().then(() => resolve(imageUrl)).catch(reject)
      } else {
        resolve(imageUrl)
      }
    }
    image.src = imageUrl
  })
}

export default preloadImage
